import { render, staticRenderFns } from "./OtherStatReport.vue?vue&type=template&id=0e15e0e6&scoped=true&"
import script from "./OtherStatReport.vue?vue&type=script&lang=js&"
export * from "./OtherStatReport.vue?vue&type=script&lang=js&"
import style0 from "./OtherStatReport.vue?vue&type=style&index=0&id=0e15e0e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e15e0e6",
  null
  
)

export default component.exports